var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { DataGrid } from '@mui/x-data-grid';
import { Box } from '@mui/material';
import { getDataGridLocaleText } from '../../../../application/common/constants/get-data-grid-locale-text';
export var TechniciansDatagrid = function (_a) {
    var technicians = _a.technicians, columns = _a.columns, rowCount = _a.rowCount, paginationModel = _a.paginationModel, onPaginationModelChange = _a.onPaginationModelChange, onSortModelChange = _a.onSortModelChange, onFilterModelChange = _a.onFilterModelChange, filterModel = _a.filterModel, isXs = _a.isXs, isscreen600900 = _a.isscreen600900, iscreen9001200 = _a.iscreen9001200, isscreen600900Landscape = _a.isscreen600900Landscape, isscreen9001200Landscape = _a.isscreen9001200Landscape;
    return (_jsx(_Fragment, { children: _jsx(Box, { padding: '16px', mt: isXs || iscreen9001200 || isscreen600900 || iscreen9001200 || isscreen600900Landscape
                ? 1
                : '', sx: {
                backgroundColor: 'white',
                borderRadius: '16px',
                boxShadow: '0 24px 48px 0 #919EAB29',
                position: 'relative',
                height: __assign(__assign(__assign({ xs: 'calc(100svh - 225px)', sm: 'calc(100svh - 170px)' }, (isscreen600900 && { sm: 'calc(100svh - 300px)' })), (isscreen600900Landscape && { sm: '400px' })), (isscreen9001200Landscape
                    ? { sm: '400px' }
                    : iscreen9001200
                        ? { sm: 'calc( 100svh - 247px)' }
                        : {}))
            }, children: _jsx(DataGrid, { localeText: getDataGridLocaleText(), getRowHeight: function () { return 'auto'; }, rows: technicians, columns: columns, disableColumnSelector: true, disableRowSelectionOnClick: true, rowCount: rowCount, rowSelection: false, filterMode: 'server', filterDebounceMs: 500, filterModel: filterModel, onFilterModelChange: onFilterModelChange, pagination: true, paginationModel: paginationModel, paginationMode: 'server', pageSizeOptions: [10, 20, 50, 100], onPaginationModelChange: onPaginationModelChange, sortingMode: 'server', onSortModelChange: onSortModelChange, disableColumnResize: true, slotProps: {
                    filterPanel: {
                        filterFormProps: {
                            operatorInputProps: {
                                variant: 'standard'
                            },
                            columnInputProps: {
                                variant: 'standard'
                            },
                            valueInputProps: {
                                InputComponentProps: {
                                    variant: 'standard'
                                }
                            }
                        },
                        sx: {
                            '& .MuiAutocomplete-clearIndicator': {
                                right: '-10px',
                                width: '30px',
                                height: '30px'
                            },
                            '& input': {
                                fontSize: '0.875rem'
                            }
                        }
                    }
                }, sx: {
                    borderWidth: '0px',
                    backgroundColor: 'transparent',
                    overflow: 'auto',
                    outline: 'none',
                    '& .MuiDataGrid-row': {
                        cursor: 'default',
                        paddingTop: '8px',
                        paddingBottom: '8px'
                    },
                    '&, [class^=MuiDataGrid]': { border: 'none' },
                    '& .MuiDataGrid-columnHeader, & .MuiDataGrid-columnHeaderTitleContainer': {
                        backgroundColor: '#F4F6F8 !important',
                        border: 'none'
                    },
                    '& .MuiDataGrid-selectedRowCount': {
                        display: 'none'
                    }
                } }) }) }));
};
